import "@fontsource/m-plus-1p/400.css"
import { ExpandMore } from '@mui/icons-material'
import { Link, useLocation } from "react-router-dom"
import * as React from "react"
import { Button, Col, Container, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { Parallax } from '../components/parallax'
import { color_main } from '../style/color'
import "../style/custom.scss"
import { Header, header_height } from "./header"
import "./layout.css"
import img_bg from "../images/top.jpg"
import bnr_vintage_blog from "../images/bnr_vintage_blog.png"
import bnr_shinmei_conveyor from "../images/bnr_shinmei_conveyor.png"
import bnr_shinmei_conveyor_blog from "../images/bnr_shinmei_conveyor_blog.png"
const { useEffect } = React;

interface IProps {
  children: React.ReactNode;
  title?: string;
  subtitle?: string;
}

export const Layout: React.FC<IProps> = ({ children, title, subtitle }) => {
  const { t } = useTranslation()
  const location = useLocation();

  const baseTitle = t("METADATA.BASE_TITLE");

  useEffect(() => {
    if (title) {
      document.title = `${title} | ${baseTitle}`;
    } else {
      document.title = baseTitle;
    }
  }, [title, baseTitle]);

  return (
    <div id="root">
      <Header path={location.pathname} />
      <Parallax img={img_bg}>{location.pathname === "/" ? <IndexHeader /> : <NormalHeader title={title || ""} subtitle={subtitle || ""} />}</Parallax>
      {children}
      <Container className="my-5">
        <div className="text-center">
          <FooterBanners />
          <div><small>Copyright © 2005 - {new Date().getFullYear()} MKSC All rights reserved.</small></div>
          <div className="d-inline-flex">
            <small><Link to="/privacy-policy">{t("FOOTER.PRIVACY_POLICY")}</Link></small>
            <small className="mx-2">|</small>
            <small><Link to="/employment">{t("FOOTER.EMPLOYMENT")}</Link></small>
          </div>
        </div>
      </Container>
      {
      //<AcceptCookies />
      }
    </div>
  )
}

const footer_banners = [
  { href: "https://blog.shinmei.co.jp/restore/", img: bnr_vintage_blog, alt: "旧車レストア BLOG" },
  { href: "https://conveyor.shinmei.co.jp/", img: bnr_shinmei_conveyor, alt: "新明コンベア 販売サイト" },
  { href: "https://conveyor-blog.shinmei.co.jp/", img: bnr_shinmei_conveyor_blog, alt: "コンベア専門 BLOG" },
]

const FooterBanners = () => {
  return (
    <div className="d-flex flex-wrap justify-content-center align-items-center gap-3 mb-4">
      {footer_banners.map((banner) => (
        <a key={banner.href} href={banner.href} target="_blank" rel="noopener noreferrer">
          <img className="footer-banner" src={banner.img} alt={banner.alt} />
        </a>
      ))}
    </div>
  )
}

interface INormalHeaderProps {
  title: string
  subtitle: string
}

const NormalHeader = ({title, subtitle}: INormalHeaderProps) => {
  return (
    <Container>
      <article>
        <div style={{height: `${header_height * 0.5}rem`}} />
        <div className="w-100 d-flex text-light text-center justify-content-center align-items-center" style={{height: `${header_height * 2}rem`}}>
          <div className="animation-slide-in">
            <h1 className="mb-0">{title}</h1>
            {subtitle !== "" && (
              <small>{subtitle}</small>
            )}
          </div>
        </div>
      </article>
    </Container>
  )
}



const IndexHeader = () => {
  const { t } = useTranslation("translations", { keyPrefix: "INDEX.HEADER" })

  return (
    <Container>
      <article style={{height: "100vh"}}>
        <div className="h-100 d-flex justify-content-center align-items-center text-light position-relative">
          <div className="position-absolute" style={{ bottom: '3rem', left: '50%', transform: 'translateX(-50%)' }}>
            <div className="bg-light text-dark rounded-pill pt-4 px-2">
              <div className="animation-slide-down" style={{maxWidth: "2rem"}}>
                <ExpandMore fontSize="large" style={{marginLeft: "-4px"}}/>
              </div>
            </div>
          </div>
          <Row className="animation-slide-in">
            <Col md={8} className="mt-auto mb-md-0 mb-4">
              <h1>PROVIDE <strong style={{color: color_main}}>VALUE</strong> TO <strong style={{color: color_main}}>CUSTOMERS</strong></h1>
              <h1>WITH OUR <strong style={{color: color_main}}>SOFTWARE</strong>.</h1>
            </Col>
            <Col md={4} className="d-flex">
              <div className="my-auto w-100">
                <Link to="/works"><Button variant="outline-light" className="w-100 rounded-0 mb-4">{t("WORKS")}</Button></Link>
                <Link to="/#contact"><Button variant="outline-light" className="w-100 rounded-0">{t("CONTACT")}</Button></Link>
              </div>
            </Col>
          </Row>
        </div>
      </article>
    </Container>
  )
}
